export default "__VITE_ASSET__5af0e8b2__"